import type { AdminCrewReportImportModalActionsProps } from "../../models/admin-crew-report.models";
import { adminStyles } from "../../styles/admin.styles";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

const AdminCrewReportImportModalActions = ({ onClose, onExport }: AdminCrewReportImportModalActionsProps) => (
  <footer
    role="group"
    aria-label="Crew Report import actions"
    className="admin-crew-report-import-print-hidden flex flex-wrap justify-end gap-2 border-t border-[#D8E6E3] px-5 py-4 dark:border-gray-700"
  >
    <button
      type="button"
      className={twMerge(
        adminStyles.button.primary,
        "w-auto border border-green bg-white text-green hover:bg-[#E9F4F3] dark:bg-gray-800 dark:hover:bg-gray-700",
      )}
      onClick={onExport}
    >
      <ArrowDownTrayIcon className="h-5 w-5" />
      PDF Export
    </button>
    <button
      type="button"
      className={twMerge(adminStyles.button.primary, adminStyles.button.safe, "w-auto")}
      onClick={onClose}
    >
      Close
    </button>
  </footer>
);

export default AdminCrewReportImportModalActions;
